module.exports = __webpack_public_path__ + "img/home_5th_ctn@2x.e0e13645.png";